export default "__VITE_ASSET__CIvDFn9u__"